module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("This book is a publication of")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Indiana University Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("601 North Morton Street"), _c('br'), _vm._v("Bloomington, Indiana 47404-3797 USA")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("iupress.indiana.edu")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_c('em', [_vm._v("Telephone orders")]), _vm._v("      800-842-6796"), _c('br'), _c('em', [_vm._v("Fax orders")]), _vm._v("     812-855-7931")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("© 2013 by Rebecca McClanahan")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("The epigraph reproduces portions of “The Family Is All There Is,” and is reprinted from "), _c('em', [_vm._v("Firekeeper: New and Selected Poems")]), _vm._v(" (Minneapolis: Milkweed Editions). Copyright © 1994 by Pattiann Rogers. Reprinted with permission from Milkweed Editions.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("No part of this book may be reproduced or utilized in any form or by any means, electronic or mechanical, including photocopying and recording, or by any information storage and retrieval system, without permission in writing from the publisher. The Association of American University Presses’ Resolution on Permissions constitutes the only exception to this prohibition. "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/f00vi-01.jpg"
    }
  }), _vm._v(" The paper used in this publication meets the minimum requirements of the American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI Z39.48-1992.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MANUFACTURED IN THE UNITED STATES OF AMERICA")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("Cataloging information is available from the Library of Congress"), _c('br'), _vm._v("ISBN 978-0-253-00859-6 (paper)"), _c('br'), _vm._v("ISBN 978-0-253-00867-1 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightt"
  }, [_vm._v("1 2 3 4 5   18 17 16 15 14 13")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 75
// module chunks = 0